import { FilterCategory, SearchFilterBase, SearchFilterType } from '../types';

export default function foundedYearFilterConfig(): SearchFilterBase {
  return {
    id: 'Founded Year',
    name: 'Founded Year',
    icon: 'date-range',
    index: 18,
    type: SearchFilterType.ROOT,
    category: [FilterCategory.COMPANY_DATA],
    utils: {
      tags: {
        config: {
          showAsCard: true,
          tagsCardTitle: 'Founded In',
        },
      },
    },
    pinned: true,
    items: [
      {
        type: SearchFilterType.NUMBER_RANGE,
        icon: undefined,
        index: 0,
        layer: 4,
        field: 'year_founded',
        key: 'year_founded',
        name: 'Founded Year Range',
        metadata: { color: 'primary' },
      },
    ],
  };
}
